export class GlobalLoader {
  xhrNumber: number;
  timeout: number;

  constructor(xhrNumber = 0, timeout = 0) {
    this.xhrNumber = xhrNumber;
    this.timeout = timeout;
  }
}
